import React, { FC, useEffect, useRef, useState } from 'react';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@mui/styles';
import { useExceptionWords } from 'hooks/entityHooks';
import { PreLoader } from 'Components/PreLoader';
import { ExceptionWordsTable } from 'Components/ExceptionWordsTable';
import { ExceptionWordDialog } from '../../Components/Dialogs/ExceptionWordDialog';
import classes from './ExceptionWords.module.scss';
import { ReactComponent as ClearSearch } from '../../assets/images/clearSearch.svg';

const useStyles = makeStyles({
  root: {
    width: '77%',
    fontFamily: 'HelveticaNeueCyr',
    background: '#FFFFFF',
    '&::placeholder': {
      color: '#CACED2',
    },
    // borderColor: '#EB564F',
    '&.Mui-focused': {
      border: '1px solid #FF7221',
      color: '#FF7221',
    },
    '&.MuiOutlinedInput': {
      borderColor: '#FF7221',
    },
  },
  emptyInput: {
    maxHeight: 44,
    borderColor: '#CACED2',
    '&.Mui-focused': {
      borderColor: '#FF7221',
      // color: '#EB564F',
    },
  },
  input: {
    maxHeight: 44,
    borderColor: '#FF7221',
    '&.Mui-focused': {
      borderColor: '#FF7221',
      // color: '#EB564F',
    },
  },
});

const filterKey = 'filter[text]';

const defaultSearchParams = {
  [filterKey]: '',
};

export const ExceptionWords: FC = () => {
  const style = useStyles();
  const searchParams = useRef<URLSearchParams>(
    new URLSearchParams(defaultSearchParams),
  );

  const {
    createEntity,
    updateEntity,
    entityList: list,
    getEntityList,
    initLoading,
  } = useExceptionWords();

  useEffect(() => {
    getEntityList();
  }, []);

  const handleSearchChange = (value: string) => {
    searchParams.current.set(filterKey, value);

    getEntityList(searchParams.current);
  };

  return (
    <div
      className={classes.body}
      style={{
        marginTop: 20,
      }}
    >
      <>
        <div className={classes.body__header}>
          <FormControl className={style.root}>
            <OutlinedInput
              className={style.input}
              placeholder="Введите слово"
              value={searchParams.current.get(filterKey) ?? ''}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <ClearSearch
                    onClick={() => handleSearchChange('')}
                    style={{ cursor: 'pointer' }}
                  />
                </InputAdornment>
              }
            />
          </FormControl>

          <ExceptionWordDialog
            onSubmit={createEntity}
            fetchData={getEntityList}
          />
        </div>

        {initLoading ? (
          <PreLoader />
        ) : (
          <table className={classes.body__table}>
            <thead className={classes.body__table__head}>
              <tr className={classes.body__table__head__tr}>
                <td>Слово исключение</td>
                <td style={{ width: '18%' }}>Действия</td>
              </tr>
            </thead>
            <tbody className={classes.body__table__body}>
              <ExceptionWordsTable
                list={list}
                handleEdit={updateEntity}
                fetchData={getEntityList}
              />
            </tbody>
          </table>
        )}
      </>
    </div>
  );
};
